import { render, staticRenderFns } from "./newnew.vue?vue&type=template&id=6f58c5f4&"
import script from "./newnew.vue?vue&type=script&lang=js&"
export * from "./newnew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports